import MailThread from "@/components/mailThread/MailThread";
import Email, { MailsListId } from "@/domain/entities/emails/Email";
import EmailAttachment from "@/domain/entities/emails/EmailAttachement";
import useSetMailEditor from "@/hooks/useSetMailEditor";
import useSuggestion from "@/hooks/useSuggestion";
import { cn } from "@/lib/utils";
import { useEffect, useRef, useState } from "react";

type VistassistantMailFullViewProps = {
    mail?: Email;
    listId: MailsListId;
};

const VistassistantMailFullView = ({
    mail,
    listId,
}: VistassistantMailFullViewProps) => {
    const [attachments, setAttachments] = useState<EmailAttachment[]>([]);
    const [mailInputExpanded, setMailInputExpanded] = useState(false);
    const [pendingSuggestion, setPendingSuggestion] = useState(false);
    const toInputRef = useRef<HTMLInputElement>(null);

    // A mail opened (or refreshed) shows read-only.
    useEffect(() => {
        setMailInputExpanded(false);
    }, [mail]);

    const { editor, suggestionEditor } = useSetMailEditor(setAttachments);
    const {
        acceptOrRefuseSuggestion,
        isLoading: isLoadingSuggestion,
        isPendingChange,
        makeSuggestion,
    } = useSuggestion({
        editor,
        suggestionEditor,
        setPendingSuggestion,
        mailContent: mail?.message ?? "",
    });

    if (!editor || !suggestionEditor) {
        return null;
    }

    return (
        // In a tab of the side panel: the whole tab, white, one column (closed by the tab's cross).
        <div
            className={cn(
                "flex min-h-0 flex-1 flex-col overflow-hidden bg-white",
                !mail && "hidden",
            )}
        >
            <MailThread
                acceptOrRefuseSuggestion={acceptOrRefuseSuggestion}
                attachments={attachments}
                classname="flex-1 min-h-0 w-full"
                editor={editor}
                embedded
                isLoading={isLoadingSuggestion}
                isPendingChange={isPendingChange}
                listId={listId}
                mail={mail}
                mailInputExpanded={mailInputExpanded}
                makeSuggestion={makeSuggestion}
                pendingSuggestion={pendingSuggestion}
                setAttachments={setAttachments}
                setMailInputExpanded={setMailInputExpanded}
                setPendingSuggestion={setPendingSuggestion}
                suggestionEditor={suggestionEditor}
                toInputRef={toInputRef}
            />
        </div>
    );
};

export default VistassistantMailFullView;
